import TextSquare from '@/assets/icons/text-square.svg?react'
import Hash from '@/assets/icons/hash.svg?react'
import FileOutline from '@/assets/icons/file-outline.svg?react'
import { Calendar, SingleSelect, MultiSelect } from '@/assets/icons'
import { ColumnKind } from '../schemas'

export const columnIcons = {
  [ColumnKind.Text]: TextSquare,
  [ColumnKind.Number]: Hash,
  [ColumnKind.Date]: Calendar,
  [ColumnKind.Tags]: SingleSelect,
  file: FileOutline,
}

export function getColumnIcon(kind = ColumnKind.Text, allowMultiple = false, isFile = false) {
  if (isFile) return columnIcons.file
  if (kind === ColumnKind.Tags) return allowMultiple ? MultiSelect : SingleSelect
  return columnIcons[kind]
}
